<template>
  <v-container>
    <div class="d-flex flex-wrap row--dense">
      <div class="col col-12 col-md-4">
        <v-text-field
          v-model="step.name"
          :rules="rules.name"
          counter="255"
          maxlength="255"
          clearable
          dense
          outlined
          :label="$t('commons.name')"
        />
      </div>
      <div class="col col-12 col-md-4">
        <DatetimePicker
          v-model="step.start_date"
          :max="getMinDatetime(maxDatetime, step.deadline)"
          :min="minDatetime"
          :textFieldProps="{
            dense: true,
            label: $t('commons.date.start_date'),
            rules: rules.start_date
          }"
        />
      </div>
      <div class="col col-12 col-md-4">
        <DatetimePicker
          v-model="step.deadline"
          :disabled="!step.start_date"
          :max="maxDatetime"
          :min="step.start_date"
          :textFieldProps="{
            dense: true,
            label: $t('commons.date.end_date'),
            rules: rules.deadline
          }"
        />
      </div>
    </div>
    <div class="d-flex justify-end mt-6 mb-4">
      <avs-createButton
        small
        @click.stop="addTask()"
        :spantext="$t('actions.add', { entity: $tc('commons.task', 1).toLowerCase() })"
        :name="$t('actions.new_female', { entity: $tc('commons.task', 1).toLowerCase() })"
      >
      </avs-createButton>
    </div>
    <div class="d-flex row--dense">
      <v-list class="ml-2">
        <v-list-item
          v-for="(task, taskIndex) in step.tasks.filter(s => !s.deleted)"
          :key="taskIndex"
        >
          <v-list-item-content>
            <div class="d-flex flex-wrap row--dense">
              <!-- <v-col
                class="col-12 pb-0 mb-0"
                v-if="pcq_dsi"
              >
                <v-checkbox v-model="task.create_pcq_dsi">
                  <template v-slot:label>
                    <div>{{ $t("categories.pcqdsi.is_pcq_dsi") }}</div>
                  </template>
                </v-checkbox>
              </v-col> -->
              <div class="col-6 col-lg-3">
                <v-text-field
                  v-model="task.name"
                  :rules="rules.task.name"
                  counter="255"
                  maxlength="255"
                  clearable
                  dense
                  outlined
                  :label="$t('categories.project.task')"
                />
              </div>
              <div class="col-6 col-lg-2">
                <v-select
                  v-model="task.status"
                  :rules="rules.task.status"
                  :items="STATUS_ITEMS"
                  dense
                  outlined
                  :label="$t('commons.status.name')"
                ></v-select>
              </div>
              <div class="col-6 col-lg-3">
                <DatetimePicker
                  v-model="task.start_date"
                  :disabled="!step.start_date || !step.deadline"
                  :max="getMinDatetime(step.deadline, task.deadline)"
                  :min="step.start_date"
                  :textFieldProps="{
                    dense: true,
                    label: $t('commons.date.start_date'),
                    rules: rules.task.start_date
                  }"
                />
              </div>
              <div class="col-6 col-lg-3">
                <DatetimePicker
                  v-model="task.deadline"
                  :disabled="!task.start_date"
                  :max="step.deadline"
                  :min="task.start_date"
                  :textFieldProps="{
                    dense: true,
                    label: $t('commons.date.end_date'),
                    rules: rules.task.deadline
                  }"
                />
              </div>
              <div class="col-1 col-lg-1">
                <avs-deleteButton
                  @click="openDeleteDialog(taskIndex)"
                  :spantext="
                    $t('actions.delete', {
                      entity: $tc('commons.task', 1).toLowerCase()
                    })
                  "
                />
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <avs-deleteDialog
      v-model="deleteDialogIsOpen"
      @cancel="closeDeleteDialog"
      @delete="deleteTask"
      resource="task"
    />
  </v-container>
</template>

<script>
import { STATUS_ITEMS } from "@/utils/consts"
import { mkProjectStepTask } from "@/utils/datamodels"
import { getMinDatetime } from "@/utils/datetime"
import { required } from "@/utils/validator"
import { TaskService } from "@/services"

export default {
  name: "ProjectActivityTask",
  components: {
    DatetimePicker: () => import("@/components/inputs/DatetimePicker.vue")
  },
  props: {
    maxDatetime: {
      type: Object,
      required: true
    },
    minDatetime: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    },
    rulesUpdate: {
      type: Object,
      default: () => {}
    },
    pcq_dsi: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rules() {
      return {
        name: [required],
        start_date: [required],
        deadline: [required],
        task: {
          name: [required],
          status: [required],
          start_date: [required],
          deadline: [required]
        },
        ...this.rulesUpdate
      }
    }
  },
  data() {
    return {
      deleteDialogIsOpen: false,
      STATUS_ITEMS,
      taskIndex: null
    }
  },
  methods: {
    getMinDatetime,
    hasBeenUpdated() {
      this.$emit("updated")
    },
    addTask() {
      let order = this.step.tasks.length + 1
      this.step.tasks.push(
        mkProjectStepTask(
          this.step.start_date,
          this.step.deadline,
          order,
          this.$tc("commons.task", 1).toUpperCase()
        )
      )
    },
    deleteTask() {
      let task = this.step.tasks[this.taskIndex]
      if (task.id) {
        TaskService.remove(this, task.id).then(response => {
          this.send(
            this.$t("messages.success.deleted", { entity: this.$tc("commons.task", 1) }),
            "success"
          )
        })
        this.hasBeenUpdated()
      } else {
        this.step.tasks.splice(this.taskIndex, 1)
        this.send(
          this.$t("messages.success.deleted", { entity: this.$tc("commons.task", 1) }),
          "success"
        )
      }
      this.closeDeleteDialog()
    },
    closeDeleteDialog() {
      this.deleteDialogIsOpen = false
    },
    openDeleteDialog(taskIndex) {
      this.deleteDialogIsOpen = true
      this.taskIndex = taskIndex
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
